import React from 'react';
import { t } from '../../i18n';

const DeleteConfirmationModal = ({
  showModal,
  patientToDelete,
  onClose,
  onConfirm,
  isDeleting,
  lang
}) => {
  if (!showModal || !patientToDelete) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
              <svg
                className="w-6 h-6 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">
              {t("deletePatient", lang) || "Delete Patient"}
            </h3>
          </div>

          <p className="text-gray-600 mb-6">
            {t("deletePatientConfirmation", lang) ||
              "Are you sure you want to delete"}{" "}
            <strong>{patientToDelete.fullName}</strong>?{" "}
            {t("deletePatientWarning", lang) ||
              "This action cannot be undone and will permanently remove all patient data."}
          </p>

          <div className="flex gap-4">
            <button
              onClick={onClose}
              disabled={isDeleting}
              className={`flex-1 px-4 py-2 border border-gray-300 font-medium rounded-lg transition-colors ${
                isDeleting 
                  ? 'text-gray-400 cursor-not-allowed' 
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {t("cancel", lang) || "Cancel"}
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              className={`flex-1 px-4 py-2 font-medium rounded-lg transition-colors flex items-center justify-center ${
                isDeleting
                  ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                  : 'bg-red-600 text-white hover:bg-red-700'
              }`}
            >
              {isDeleting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Deleting...
                </>
              ) : (
                t("deletePatient", lang) || "Delete Patient"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal; 